import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import "./CheckoutAuthModal.css";

export default function CheckoutAuthModal({ open, onClose }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  if (!open) return null;

  const isLogged = !!localStorage.getItem("cliente_token");

  return createPortal(
    <div
      className="checkout-auth-scope"
      role="dialog"
      aria-modal="true"
      aria-labelledby="checkout-auth-title"
    >
      <div className="checkout-auth-overlay" onClick={onClose}>
        <div
          className="checkout-auth-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="checkout-auth-top-line" />

          <span className="checkout-auth-badge">Checkout</span>

          <h2 id="checkout-auth-title">Continuar al checkout</h2>

          <p className="checkout-auth-sub">
            Para continuar con tu pedido, inicia sesión o crea una cuenta.
          </p>

          <div className="checkout-auth-actions">
            <button
              className="checkout-auth-btn checkout-auth-login"
              onClick={() => {
                if (isLogged) {
                  navigate("/store/checkout/datos");
                } else {
                  navigate("/cliente/login", {
                    state: {
                      redirectTo: "/store/checkout/datos",
                      mode: "login",
                    },
                  });
                }
              }}
            >
              Iniciar sesión
            </button>

            <button
              className="checkout-auth-btn checkout-auth-register"
              onClick={() =>
                navigate("/cliente/login", {
                  state: {
                    redirectTo: "/store/checkout/datos",
                    mode: "register",
                  },
                })
              }
            >
              Crear cuenta y continuar
            </button>
          </div>

          <button className="checkout-auth-close" onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}